/* eslint-disable prettier/prettier */
<template>
  <b-container class="mt-3 pt-5 pb-5">
    <b-row>
      <b-col md="8">
        <h1 class="headline1">Welcome to ØREDEV 2023! </h1>
        <h1 class="headline1">HALT AND CATCH FIRE
</h1>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6">
        <b-img
          class="d-block d-md-none mt-4 mb-4"
          fluid
          src="static/Halt_and_catch_fire_illustration_grain.png"
        ></b-img>
        <p>
          <strong>
            Reimagine tech and its impact in the world! 
            

          </strong>
          <br />
          <br />
          Explore Øredev's 17th Edition theme, "Halt and Catch Fire," where we challenge the conventional and invite you to envision a world transformed by technology, starting from scratch.
           <br /> In a scenario where one command could reshape everything, we ask: What if we could do things differently? Equipped with today's knowledge, how would we reinvent the tech landscape? This theme taps into our shared fascination with apocalyptic scenarios, offering a chance not for the world to end, but for a fresh start on a blank canvas.


          <br />
          <br />
          Join us to contemplate this unique opportunity to rethink our impact on the world. Let's delve into endings and new beginnings, daring to bid farewell to what no longer serves us. Embrace the evolution, welcome transitions, and be part of a community with the courage to forge ahead.


          <br />
          Experience the "Halt and Catch Fire" theme with us. Welcome to ØREDEV 2023, more than just a tech or IT conference, it’s where we redefine possibilities!

          <br />
          <br />
          
          <br /><br />
          
        </p>
      </b-col>
      <b-col md="6">
        <div>
          <b-img
            class="d-none d-md-block"
            fluid
            src="static/Halt_and_catch_fire_illustration_grain.png"
          ></b-img>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import VueObserveVisibility from "vue-observe-visibility";

export default {
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      //const spin = localStorage.getItem("spinning");

      /*  if (spin) {
        this.isVisible = false;
        return;
      } */

      this.isVisible = isVisible;
      // localStorage.setItem("spinning", "true");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

@media screen and (max-width: 1200px) {
  .pathActive {
    background-size: 100%;
  }
}
@media screen and (max-width: 767px) {
  .pathActive {
    background-size: 150%;
  }
}
@media screen and (max-width: 375px) {
  .pathActive {
    background-size: 175%;
  }
}

p {
  color: $text-dark;
}

h1 {
  color: #7140c4;
}

.headline1 {
  font-size: 4rem;
  text-transform: uppercase;
  color: $orange;
}
</style>



// WEBPACK FOOTER //
// src/components/ThemeIntroduction.vue